module.exports = __webpack_public_path__ + "img/img21.c1815f86.svg";